// @ts-ignore

import XLSX, { BookType } from "xlsx";
import { Typography, Box } from "@material-ui/core";
import { Tooltip } from "components/shared";
import { CsvIcon } from "components/Icons";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { getAllFromCorreios,getAllInJsonFromCorreios } from '../../../services/logCorreiosService'

import save from "save-file";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dwButtonExcell: {
      alignSelf: "center",
      marginRight: 10,

      height: 40,
      width: 40,
      background: "transparent",

      color: "white",
      border: "none",
      borderRadius: 5,
      cursor: "pointer",
      "&:hover": {
        background: "#dde0e2",
        border: "1px solid lightgreen",
      },
    },
    box: {
      display: "flex",
      alignItems: "center",
      margin: "12px 0 0 0",
    },
  })
);

type TableExcellCorreios = {
  mcm_id: any;
};

export default function TableCorreiosDownload({ mcm_id }: TableExcellCorreios) {
    const classes = useStyles();

    const downloadData = (type:BookType) => {

      const load_csv = async() => {
        const logs = await getAllFromCorreios(mcm_id);        
        const now = new Date();
        const file_name = `${mcm_id}_${now.getFullYear()%2000}${(now.getMonth()+1).toString().padStart(2,"0")}${now.getDate().toString().padEnd(2,"0")}${now.getHours().toString().padStart(2,"0")}${now.getMinutes().toString().padStart(2,"0")}_LOG_CORREIOS_MODULOCKER.csv`;      
        await save(logs,file_name);
      }

      const load_xls = async () => {
        const logs = await getAllInJsonFromCorreios(mcm_id);
        const now = new Date();
        const file_name = `${mcm_id}_${now.getFullYear()%2000}${(now.getMonth()+1).toString().padStart(2,"0")}${now.getDate().toString().padEnd(2,"0")}${now.getHours().toString().padStart(2,"0")}${now.getMinutes().toString().padStart(2,"0")}_LOG_CORREIOS_MODULOCKER.xlsx`;      

        let buffer = logs?.data.map((log)=>{
            return {
                data: log.DHINSTALACAO,
                complemento: log.COMPLEMENTO,
                usuario: log.NMUSUARIO,
                perfil: log.PERFIL,
                box: log.NUMERO,
                descricao: log.DSNOTIFCODEEXT
            }
        });

        const workBook = XLSX.utils.book_new();
        const workSheet = XLSX.utils.json_to_sheet(buffer);

        XLSX.utils.book_append_sheet(workBook, workSheet, type);
        XLSX.writeFile(workBook, `${file_name}`);        
      }

      if(type==='csv')
        load_csv();
      else if(type==='xlsx')
        load_xls();                  
    }
  
    const downloadExcel = (choice: BookType) => {

        downloadData(choice);
    }

  return (
    <Box className={classes.box}>
      <Typography
        variant="caption"
        style={{
          marginRight: 5,
        }}
      >
        Exportar:
      </Typography>
      <Tooltip title="Exportar CSV">
        <div>
          <button
            type="button"
            className={classes.dwButtonExcell}
            onClick={() => downloadExcel("csv")}
          >
            <img src={CsvIcon} alt="CSV" width="30px" />
          </button>
        </div>
      </Tooltip>
    </Box>
  );
}

/*
<Tooltip title="Exportar para o Excel">
<div>
  <button
    type="button"
    className={classes.dwButtonExcell}
    onClick={() => downloadExcel("xlsx")}
  >
    <img src={ExcellIcon} alt="Excel" width="30px" />
  </button>
</div>
</Tooltip>
*/